import { render, staticRenderFns } from "./hqcontact-close-flie.vue?vue&type=template&id=52cc4db7&scoped=true&"
import script from "./hqcontact-close-flie.vue?vue&type=script&lang=js&"
export * from "./hqcontact-close-flie.vue?vue&type=script&lang=js&"
import style0 from "./hqcontact-close-flie.vue?vue&type=style&index=0&id=52cc4db7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cc4db7",
  null
  
)

export default component.exports